import { createReducer } from '@reduxjs/toolkit';
import { SearchShape } from './model';
import * as searchActions from './actions';
import * as appActions from '../app/actions';
import * as lastStateActions from '../lastState/actions';

const initial: SearchShape = {
  text: '',
  options: {
    searchInLayers: false,
    searchInArchives: false,
    searchWithAi: false,
  },
  uploadData: undefined,
  similarAsset: undefined,
};

export const searchReducer = createReducer<SearchShape>(initial, (builder) =>
  builder
    .addCase(appActions.resetFilters, (s, a) => {
      if (a.payload.preserveSearch) {
        return;
      }
      s.text = initial.text;
      s.uploadData = initial.uploadData;
    })
    .addCase(searchActions.queryChanged, (s, a) => {
      s.text = a.payload.text;
      s.uploadData = a.payload.uploadData;
    })
    .addCase(searchActions.similarAssetChanged, (s, a) => {
      s.similarAsset = a.payload.similarAsset;
    })
    .addCase(searchActions.optionsChanged, (s, a) => {
      s.options = a.payload.options;
    })
    .addCase(lastStateActions.applied, (s, a) => {
      s.text = a.payload?.state.data.search.text ?? initial.text;
      s.uploadData = a.payload?.state.data.search.uploadData ?? initial.uploadData;
      s.options.searchInLayers =
        a.payload?.state.data.search.options?.searchInLayers ?? initial.options.searchInLayers;
      s.options.searchInArchives =
        a.payload?.state.data.search.options?.searchInArchives ?? initial.options.searchInArchives;
      s.options.searchWithAi =
        a.payload?.state.data.search.options?.searchWithAi ?? initial.options.searchWithAi;
    }),
);
